import BackstageComment from './BackstageComment.interface';
import { UserData } from './UserData.interface';

export default interface Backstage {
  id: number;
  user?: UserData;
  content?: string;
  images: string[];
  videos: string[];
  comments: BackstageComment[];
  likedBy?: number[];
  createdDate: string;
  updatedDate: string;
  isPremium: boolean;
  usersWithAccess?: number[];
  userWithAccess?: number;
  price?: string;
  splitWith?: UserData[];
  splitPercent?: number;
}








export enum PostType {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
}

export interface IMediaFile {
  type: PostType;
  url: string;
}
